import { API } from "../api/API";
import { validateResponseStatus } from "../utils";

export const getAll = async (token, logOut) => {
  const result = await API()
    .post("academy/course/getByApp", { idApplication: 10 })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return [];
  }
};

export const get = async (token) => {
  const result = await API()
    .post("academy/course/getByApp", { idApplication: 10 })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return [];
  }
};

export const getByCode = async (token, code) => {
  const result = await API()
    .post("academy/course/getByCode", { code })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return [];
  }
};

export const getClosure = async (token, courseId) => {
  const result = await API()
    .post("academy/course/getClosure", courseId)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return [];
  }
};

export const validateAccess = async (contactRelationId, courseId) => {
  const result = await API()
    .post("academy/purchaseDetail/get", { courseId, contactRelationId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data.data;
  } else {
    return [];
  }
};
